import { ChecklistStatus } from "models/enumerations/notebooks/checklist-item-status";
import { ChecklistItemRecord } from "models/view-models/block-configurations/checklist-item-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface ChecklistItemPathParams {
    id?: number;
}

export interface ChecklistItemQueryParams {}

export interface ChecklistItemCreateParams {
    configurationId: number;
    precedingItemId?: number;
    text?: string;
}

export interface ChecklistItemUpdateParams {
    isChecked: boolean;
    status?: ChecklistStatus;
    text: string;
}

export interface MoveChecklistItemPathParams {
    movingChecklistItemId: number;
    precedingChecklistItemId?: number;
}

const resourceType = ChecklistItemRecord;
const baseEndpoint = "checklistitems";
const resourceEndpoint = `${baseEndpoint}/:id`;
const moveEndpoint = `${baseEndpoint}/move`;

const ChecklistItemService = {
    useCreate: ServiceHookFactory.useCreateFromPostParams<
        ChecklistItemRecord,
        ChecklistItemCreateParams
    >(resourceType, baseEndpoint),
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        ChecklistItemRecord,
        ChecklistItemUpdateParams,
        ChecklistItemPathParams
    >(resourceType, resourceEndpoint),
    useDelete: ServiceHookFactory.useDelete(resourceEndpoint),
    move: ServiceFactory.patch<
        ChecklistItemRecord,
        ChecklistItemPathParams,
        MoveChecklistItemPathParams
    >(resourceType, moveEndpoint),
    useMove: ServiceHookFactory.usePatch<
        Array<Array<number>>,
        ChecklistItemPathParams,
        MoveChecklistItemPathParams
    >(Array, moveEndpoint),
};

export default ChecklistItemService;
